import {IsMobileDevice, GetImagePromise, NormalizeByRange, Clamp} from "../../Utility/UtilityMethod.js";
export class MaskHighLight {
  constructor(webgl, config) {
    this.currentIndex = 0;
    this.rotateCount = 0;
    this._front_textures = [];
    this._highlight_textures = [];
    this.IsMobileDevice = false;
    this.Identifier = 0;
    this.LerpValue = 0;
    this._config = config;
    this.IsMobileDevice = IsMobileDevice();
    this._recordTexRotTime = this._config.texture_rotation_time;
    this.inputInteractionType = {
      mouse_screenpos_x: 0,
      mouse_screenpos_y: 0,
      input_enable: !this.IsMobileDevice
    };
  }
  async CacheMaskTexture() {
    this.maskTexType = this.IsMobileDevice ? this._config.mobile_textures : this._config.desktop_textures;
    let texturePromiseArray = [];
    texturePromiseArray.push(GetImagePromise(this._config.noise_tex_path));
    for (let i = 0; i < this.maskTexType.count; i++) {
      texturePromiseArray.push(GetImagePromise(this.maskTexType.front_textures[i]));
      texturePromiseArray.push(GetImagePromise(this.maskTexType.highlight_textures[i]));
    }
    let textureArray = await this.LoadTextures(texturePromiseArray);
    this._noise_texture = textureArray[0];
    for (let i = 0; i < this.maskTexType.count; i++) {
      let index = i * 2 + 1;
      this._front_textures.push(textureArray[index]);
      this._highlight_textures.push(textureArray[index + 1]);
    }
  }
  GetCurrentPairTexture() {
    return [this._front_textures[this.currentIndex], this._highlight_textures[this.currentIndex]];
  }
  GetPairTexture(index) {
    if (index >= this.maskTexType.count)
      return null;
    return [this._front_textures[index], this._highlight_textures[index]];
  }
  IncrementIndex() {
    this.rotateCount++;
    return this.currentIndex = (this.currentIndex + 1) % this.maskTexType.count;
  }
  OnUpdate(time, frontTexA, highlightTexA, frontTexB, highlightTexB) {
    if (!this.IsMobileDevice) {
      return;
    }
    if (time < this._recordTexRotTime) {
      if (this.rotateCount == 0) {
        this.LerpValue = 1;
        return;
      }
      this.LerpValue = Clamp(NormalizeByRange(time, this._recordTexRotTime - this._config.texture_rotation_time, this._recordTexRotTime - this._config.texture_transition_time), 0, 1);
      if (this.Identifier == 1)
        this.LerpValue = 1 - this.LerpValue;
      return;
    }
    this._recordTexRotTime = time + this._config.texture_rotation_time;
    let currentIndex = this.IncrementIndex();
    let currentTextureSet = this.GetPairTexture(currentIndex);
    this.Identifier = this.rotateCount % 2;
    if (this.Identifier == 0) {
      frontTexB.subimage(currentTextureSet[0]);
      highlightTexB.subimage(currentTextureSet[1]);
      return;
    }
    if (this.Identifier == 1) {
      frontTexA.subimage(currentTextureSet[0]);
      highlightTexA.subimage(currentTextureSet[1]);
      return;
    }
  }
  LoadTextures(texturePromise) {
    return Promise.all(texturePromise).then((values) => {
      return values;
    });
  }
  OnMouseMoveEvent(screen_x, screen_y) {
    this.inputInteractionType.mouse_screenpos_x = screen_x;
    this.inputInteractionType.mouse_screenpos_y = screen_y;
  }
}
